import React from 'react';
import { withRouter, Switch } from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
import { AuthProvider } from './context/AuthContext';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';
import LayoutAlternative from './layouts/LayoutAlternative';
import LayoutSignin from './layouts/LayoutSignin';

// Views 
import Home from './views/Home';
import Secondary from './views/Secondary';
import Login from './views/Login';
import Signup from './views/Signup';
import ForgotPassword from './views/ForgotPassword';
import ResetPassword from './views/ResetPassword';
import Account from './views/Account';
import Download from './views/Download';
import TermsAndConditions from './views/TermsAndConditions';
import DataProcessingAgreement from './views/DataProcessingAgreement';
import PrivacyPolicy from './views/PrivacyPolicy';

class App extends React.Component {

  componentDidMount() {
    document.body.classList.add('is-loaded')
    this.refs.scrollReveal.init();
  }

  // Route change
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.refs.scrollReveal.init();
    }
  }

  render() {
    return (
      <AuthProvider>
        <ScrollReveal
          ref="scrollReveal"
          children={() => (
            <Switch>
              <AppRoute exact path="/" component={Home} layout={LayoutDefault} />
              <AppRoute exact path="/secondary" component={Secondary} layout={LayoutAlternative} />
              <AppRoute exact path="/login" component={Login} layout={LayoutSignin} />
              <AppRoute exact path="/signup" component={Signup} layout={LayoutSignin} />
              <AppRoute exact path="/forgotpassword" component={ForgotPassword} layout={LayoutSignin} />
              <AppRoute exact path="/reset-password" component={ResetPassword} layout={LayoutSignin} />
              <AppRoute exact path="/account" component={Account} layout={LayoutDefault} requireAuth />
              <AppRoute exact path="/download" component={Download} layout={LayoutDefault} requireAuth />
              <AppRoute exact path="/terms-and-conditions" component={TermsAndConditions} layout={LayoutDefault} />
              <AppRoute exact path="/data-processing-agreement" component={DataProcessingAgreement} layout={LayoutDefault} />
              <AppRoute exact path="/privacy-policy" component={PrivacyPolicy} layout={LayoutDefault} />
            </Switch>
          )} />
      </AuthProvider>
    );
  }
}

export default withRouter(props => <App {...props} />);